import { TAcquisitionProviderFacade } from '../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade';
import { IPersonalInfo } from '../../providers/AcquisitionProvider/models';

export type AcquisitionErrorDispatchedState = Partial<IPersonalInfo>;

export default class AcquisitionErrorToggleEvent extends Event {
    public static EventName = 'acquisitionErrorToggle' as const;

    personalInformation: Partial<IPersonalInfo>;
    validatingState: TAcquisitionProviderFacade;

    constructor(
        dispatchingPersonalInformation: AcquisitionErrorDispatchedState,
        dispatchingValidatingState?: TAcquisitionProviderFacade,
    ) {
        super(
            AcquisitionErrorToggleEvent.EventName, 
            {
                cancelable: false,
                bubbles: false,
                composed: true, // This event is intended to be created by the Application CTA submission
            },
        );
        this.personalInformation = dispatchingPersonalInformation;
        this.validatingState = dispatchingValidatingState;
    }

    public getValue(string: keyof IPersonalInfo) {
        const fetchedEntry = this.personalInformation[string] as {value?: string, valid?: boolean};
        return fetchedEntry && fetchedEntry?.value ? fetchedEntry.value : '';
    }
}